import type { Lang } from '@portal-contract';
import { en, type MessageKey } from './en';
import { es } from './es';

export type { MessageKey };
export type Vars = Record<string, string | number>;

export const MESSAGES: Record<Lang, Record<MessageKey, string>> = { en, es };

/** Replaces `{name}` with vars[name]. A placeholder with no value is left as written so a bug is visible. */
export function interpolate(template: string, vars?: Vars): string {
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (whole, name: string) => (name in vars ? String(vars[name]) : whole));
}

export function translate(lang: Lang, key: MessageKey, vars?: Vars): string {
  return interpolate(MESSAGES[lang][key], vars);
}

/**
 * Picks the UI language before login from the browser's preferred languages
 * (navigator.languages): the first one that is Spanish or English wins; anything
 * else falls back to English. The toggle is always visible (plan 5.6).
 */
export function detectLang(preferred: readonly string[] | undefined): Lang {
  for (const tag of preferred ?? []) {
    const primary = tag.toLowerCase().split('-')[0];
    if (primary === 'es') return 'es';
    if (primary === 'en') return 'en';
  }
  return 'en';
}
